import { message, Tabs, Select } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    SelectItem,
    InputItem,
    ButtonItem,
    SwitchItem,
    ErrorItem,
    InputNumberItem
} from "../../../../Components/Items";
import TextAreItem from "../../../../Components/TextAreaItem";

const { TabPane } = Tabs;
const { Option } = Select;

class EditarRelojChecador extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarEditarRelojChecador(codigo) {
        this.props.cerrarEditarRelojChecador(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasProyectos: res.data,
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await axios
            .post(
                "relojesChecadores/datosRelojChecador",
                { empresaId: this.props.empresaId, relojChecadorId: this.props.relojChecadorId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...res.data.data,
                    });
                } else {
                    message.error("Error no se encontro informacion del reloj checador");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/editarRelojChecador",
                { ...values, empresaId: this.props.empresaId, relojChecadorId: this.props.relojChecadorId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado un reloj checador");
                    this.formRef.current.resetFields();
                    this.cerrarEditarRelojChecador(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede editar el reloj checador");
                } else {
                    message.error("Hubo un error y el reloj checador no se edito");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Editar Reloj Checador"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarRelojChecador.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="editarRelojChecador"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="Información general" key="1">
                                <FormItem
                                    name="nombre"
                                    label="Nombre"
                                    required
                                    max={100}
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Nombre" />
                                </FormItem>
                                <FormItem
                                    name="descripcion"
                                    label="Descripción"
                                    margin
                                    pattern
                                >
                                    <TextAreItem
                                        placeholder="Descripción"
                                    />
                                </FormItem>
                                <FormItem
                                    name="sn"
                                    label="Numero de serie"
                                    required
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Numero de serie" />
                                </FormItem>
                                <FormItem
                                    name="marca"
                                    label="Marca"
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Marca" />
                                </FormItem>
                                <FormItem
                                    name="modelo"
                                    label="Modelo"
                                    margin
                                    pattern
                                >
                                    <InputItem placeholder="Modelo" />
                                </FormItem>
                                <FormItem
                                    label="Proyecto"
                                    name="proyectoId"
                                    margin
                                    required
                                >
                                    <SelectItem placeholder="Proyecto">
                                        {this.state.objetoProyectos}
                                    </SelectItem>
                                </FormItem>
                            </TabPane>
                            <TabPane tab="Avanzado" key="2">
                                <FormItem
                                    name="tipoConexion"
                                    label="Tipo de conexión"
                                    margin
                                >
                                    <SelectItem placeholder="Selecciona tipo">
                                        <Option value="ADMS">ADMS (Push)</Option>
                                        <Option value="PULL">Pull (Consulta)</Option>
                                        <Option value="SDK">SDK Local</Option>
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    name="ipLocal"
                                    label="IP Local"
                                    pattern
                                    margin
                                >
                                    <InputItem placeholder="192.168.1.100" />
                                </FormItem>
                                <FormItem
                                    name="puerto"
                                    label="Puerto"
                                    margin
                                >
                                    <InputNumberItem
                                        placeholder="3001"
                                        min={1}
                                        max={65535}
                                        style={{ width: "100%" }}
                                    />
                                </FormItem>
                                <FormItem
                                    name="urlConfigurada"
                                    label="URL configurada en el reloj"
                                    pattern
                                    margin
                                >
                                    <InputItem placeholder="http://tu-servidor.com:3001" />
                                </FormItem>
                                <FormItem
                                    name="modoServidor"
                                    label="Modo Servidor"
                                    margin
                                >
                                    <SelectItem placeholder="Selecciona modo">
                                        <Option value="ADMS">ADMS</Option>
                                        <Option value="Standalone">Standalone</Option>
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    name="timezone"
                                    label="Zona Horaria"
                                    initialValue={-6}
                                    margin
                                    required
                                >
                                    <SelectItem showSearch>
                                        <Option value={-6}>
                                            America/Mexico_City -6 GMT
                                        </Option>
                                        <Option value={-7}>
                                            America/Tijuana -8 GMT
                                        </Option>
                                        <Option value={-5}>
                                            America/Monterrey -5 GMT
                                        </Option>
                                    </SelectItem>
                                </FormItem>
                                <FormItem
                                    name="requiereHTTPS"
                                    label="Requiere HTTPS"
                                    valuePropName="checked"
                                    margin
                                >
                                    <SwitchItem />
                                </FormItem>
                                <FormItem
                                    name="versionFirmware"
                                    label="Versión Firmware"
                                    margin
                                >
                                    <InputItem placeholder="Ej: Ver 8.0.4.7" />
                                </FormItem>
                                <FormItem
                                    name="macAddress"
                                    label="Dirección MAC"
                                    pattern
                                    margin
                                >
                                    <InputItem placeholder="AA:BB:CC:DD:EE:FF" />
                                </FormItem>
                            </TabPane>
                        </Tabs>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarRelojChecador);
